<template lang="pug">
    .settings(v-if='settings')
        span
            | {{ $i18n.t('trainer.trainer_gameFormSetting_difficulty') }}:
            | {{$i18n.t('common.common_gameSetting_digitCapacity' + settings.difficult.value)}}
        br
        span
            | {{ $i18n.t('trainer.trainer_gameFormSetting_visionFieldSpeed') }}:
            | {{ settings.speed }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
        br
        slot
</template>

<script>
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework',
            },
            withIcon: Boolean,
        },
    };
</script>
